export class 取込ファイル確定依頼型 {
  public 取込ファイル番号: string;
  public 更新バージョン: number;

  constructor(取込ファイル番号: string, 更新バージョン: number) {
    this.取込ファイル番号 = 取込ファイル番号;
    this.更新バージョン = 更新バージョン;
  }
}
